(function () {
  const navLinks = document.querySelectorAll(".about-section__nav__link");

  if (!navLinks.length) return;

  const sections = document.querySelectorAll(".about-section[id]");
  let activeSection = null;

  function setActiveBySection(newActiveSection) {
    if (activeSection === newActiveSection) return;
    activeSection = newActiveSection;

    const hash = `#${activeSection.id}`;

    document
      .querySelectorAll(".about-section__nav__link--active")
      .forEach((navLink) => {
        navLink.classList.remove("about-section__nav__link--active");
      });

    const nav = activeSection.querySelector(".about-section__nav");
    if (nav) {
      if (!nav.hasAttribute("tabindex")) nav.setAttribute("tabindex", "-1");
      nav.focus({ preventScroll: true });
    }

    const links = activeSection.querySelectorAll(".about-section__nav__link");
    links.forEach((navLink) => {
      if (navLink.hash === hash) {
        navLink.classList.add("about-section__nav__link--active");
      }
    });
  }

  const observer = new IntersectionObserver(
    (entries) => {
      let activeEntry = null;
      for (const entry of entries) {
        if (entry.isIntersecting) {
          if (
            !activeEntry ||
            entry.intersectionRatio > activeEntry.intersectionRatio
          ) {
            activeEntry = entry;
          }
        }
      }
      if (activeEntry) {
        setActiveBySection(activeEntry.target);
      }
    },
    {
      rootMargin: "-10% 0px -50% 0px",
      threshold: [0, 0.25, 0.5, 0.75, 1],
    },
  );

  function smoothScrollTo(element, duration = 1200) {
    const start = window.scrollY;
    const end = element.getBoundingClientRect().top + start;
    const distance = end - start;
    let startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;

      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);

      window.scrollTo(0, start + distance * easeOut(progress));

      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  sections.forEach((section) => observer.observe(section));

  navLinks.forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault();
      const target = link.href.split("#")[1];
      const targetElement = document.getElementById(target);
      if (targetElement) {
        smoothScrollTo(targetElement, 1200);
      }
    });
  });
})();
